import axios from "axios";
import store from "@/store";
import { getToken } from "@/utils/auth";

const service = axios.create({
  baseURL: process.env.VUE_APP_KW_AUTH_BASE_URL,
  // baseURL: "",
  timeout: 30000
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    if (store.getters.token) {
      config.headers["userId"] = getToken();
    } else {
      console.log(window.location.href);
      let url = window.location.href;
      if (url.indexOf("login") < 0) {
        alert("登录超时，请重新登录");
        window.location.href = "/cgxComClient/login";
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (Number(res.code) === 200) {
      return res;
    }
    return Promise.reject(res);
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default service;
